import * as companyResource from '@/modules/company/company.resource';

export function getCompanyAnalytics() {
  return new Promise((resolve, reject) =>
    companyResource
      .getCompanyAnalytics()
      .then(({ data }) => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      }));
}

export function getCurrentCompany(companyId) {
  return new Promise((resolve, reject) =>
    companyResource
      .getCurrentCompany(companyId)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      }));
}

export function updateCompany(company) {
  return new Promise((resolve, reject) =>
    companyResource
      .updateCompany(company)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      }));
}
